import React from 'react';
import { AlertTriangle, ArrowRight, Activity, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-gov-navy text-white overflow-hidden" data-id="element-106">
      {/* Abstract background pattern for visual interest without being generic */}
      <div className="absolute inset-0 opacity-10" data-id="element-107">
        <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-108">
          <path d="M0 100 C 20 0 50 0 100 100 Z" fill="currentColor" data-id="element-109" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 lg:py-32 flex flex-col lg:flex-row items-center" data-id="element-110">
        {/* Main Content */}
        <div className="w-full lg:w-3/5 pr-0 lg:pr-12 text-center lg:text-left" data-id="element-111">
          <div className="inline-flex items-center space-x-2 bg-white/10 rounded-full px-4 py-1.5 mb-6 border border-white/20" data-id="element-112">
            <Activity className="w-4 h-4 text-gov-amber" data-id="element-113" />
            <span className="text-sm font-medium tracking-wide text-gray-200" data-id="element-114">
              Protecting Our Community
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6" data-id="element-115">
            Promoting Health & <br className="hidden md:block" data-id="element-116" />
            Safety in Franklin County
          </h1>

          <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-117">
            Your central resource for public health services, environmental
            safety, permits, and community well-being initiatives.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-118">
            {/* DOMINANT CTA */}
            <a href="#report" className="group relative flex items-center justify-center w-full sm:w-auto bg-gov-amber hover:bg-gov-amberHover text-gov-navyDark font-bold text-lg py-4 px-8 rounded-md shadow-[0_0_20px_rgba(212,168,67,0.4)] hover:shadow-[0_0_25px_rgba(212,168,67,0.6)] transition-all duration-300 transform hover:-translate-y-1" data-id="element-119">
              <AlertTriangle className="w-6 h-6 mr-3" data-id="element-120" />
              Report a Public Health Concern
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-121" />
            </a>

            {/* Secondary CTA */}
            <a href="#services" className="flex items-center justify-center w-full sm:w-auto bg-transparent border-2 border-white/30 hover:border-white text-white font-semibold text-lg py-3.5 px-8 rounded-md transition-all duration-300" data-id="element-122">
              Browse Services
            </a>
          </div>
        </div>

        {/* Right side illustrative element (optional, keeps it from looking empty on large screens) */}
        <div className="hidden lg:flex w-full lg:w-2/5 justify-end relative mt-12 lg:mt-0" data-id="element-123">
          <div className="relative w-full max-w-md aspect-square rounded-full border-4 border-white/10 flex items-center justify-center p-8" data-id="element-124">
            <div className="absolute inset-0 border-2 border-gov-amber/30 rounded-full animate-[spin_60s_linear_infinite]" data-id="element-125"></div>
            <div className="w-full h-full bg-white/5 rounded-full backdrop-blur-sm flex flex-col items-center justify-center text-center p-8 border border-white/10 shadow-2xl" data-id="element-126">
              <ShieldCheck className="w-24 h-24 text-gov-amber mb-6 opacity-90" data-id="element-127" />
              <h3 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-128">
                Trusted Care
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-129">
                Serving over 1.3 million residents with dedication and
                integrity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}